import { Image, Modal } from 'react-bootstrap'
import CloseIcon from 'asset/images/close.svg'

export interface ModalCustomType {
  show: boolean
  handleClose?: () => void
  content: JSX.Element
  size?: 'sm' | 'lg' | 'xl'
}

export const ModalCustom = (props: ModalCustomType): JSX.Element => {
  return (
    <>
      <Modal
        show={props.show}
        backdropClassName="background-modal-detail-booking"
        className={'modal-detail-booking'}
        size={props.size}
      >
        <Modal.Body>
          <Image
            src={CloseIcon}
            className="modal-detail-close"
            onClick={props.handleClose}
          />
          <div className="modal-detail-sp">
            {props.content}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
